import { Card } from '../../../../components/ui/card';
import { Package, ChevronRight } from 'lucide-react';

export function EnvasesContainer({ data }) {
  return (
    <Card className="p-4">
      <div className="space-y-4">
        <div 
          className="flex items-center justify-between cursor-pointer hover:bg-gray-50 rounded-lg transition-colors p-2"
          onClick={() => console.log('Navigate to envases detail')}
        >
          <div className="flex items-center gap-2">
            <Package className="h-5 w-5 text-purple-500" />
            <h2 className="text-lg font-semibold">Vales de Envases</h2>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400" />
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-sm text-gray-500">Generados</div>
            <div className="text-xl font-bold mt-1">28</div>
          </div>
          <div>
            <div className="text-sm text-gray-500">Pagados</div>
            <div className="text-xl font-bold mt-1">23</div>
          </div>
        </div>
      </div>
    </Card>
  );
} 